import * as React from "react"
const SvgFiles = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20 19.571H9q-.825 0-1.412-.587A1.93 1.93 0 0 1 7 17.57v-14q0-.824.588-1.412A1.93 1.93 0 0 1 9 1.57h6.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4v9.175a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 20 19.57Zm0-11h-3.5q-.625 0-1.063-.437A1.45 1.45 0 0 1 15 7.07v-3.5H9v14h11zm-15 15q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 21.57v-13q0-.424.288-.712A.97.97 0 0 1 4 7.57a.97.97 0 0 1 .713.288Q5 8.146 5 8.57v13h10a.97.97 0 0 1 .713.288q.287.289.287.712a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287H5Z" />
  </svg>
)
export default SvgFiles
